// extracted by mini-css-extract-plugin
export default {"root":"IconNotification_root__9bLuQ"};